// Angular
import { Component, Inject, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';
import { MatProgressBarModule } from '@angular/material/progress-bar';

@Component({
	selector: 'kt-update-entity-dialog',
	standalone: true,
	imports: [
		CommonModule,
		MatButtonModule,
		MatProgressBarModule
	],
	templateUrl: './update-entity-dialog.component.html',
  styleUrls: ['../modal.scss']
})
export class UpdateEntityDialogComponent implements OnInit {
	// Public properties
	viewLoading: boolean = false;
	waitTime: number = 2500;
	/**
	 * Component constructor
	 *
	 * @param dialogRef: MatDialogRef<UpdateEntityDialogComponent>
	 * @param data: any
	 */
	constructor(
		public dialogRef: MatDialogRef<UpdateEntityDialogComponent>,
		@Inject(MAT_DIALOG_DATA) public data: any
	) {
		if(this.data.hasOwnProperty('waitTime')){
			this.waitTime = this.data.waitTime;
		}
	}

	/**
	 * @ Lifecycle sequences => https://angular.io/guide/lifecycle-hooks
	 */

	/**
	 * On init
	 */
	ngOnInit() {
	}

	/**
	 * Close dialog with false result
	 */
	onNoClick(): void {
		this.dialogRef.close();
	}

	/**
	 * Close dialog with true result
	 */
	onYesClick(): void {
		/* Server loading imitation. Remove this */
		this.viewLoading = true;
		setTimeout(() => {
			this.dialogRef.close(true); // Keep only this row
		}, this.waitTime);
	}
}
